import { Modal } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { Filters } from 'src/Components/Calendars/Filters';

import { Props } from './EventFilterModal.types';

const EventFilterModal = ({ open, onClose }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      opened={open}
      onClose={onClose}
      withCloseButton={true}
      title={t('planning.filters.title', 'Filtres')}
    >
      <Filters />
    </Modal>
  );
};

export default EventFilterModal;
